$(function () {
    $(document).ready(function () {
        $('.passwordValidation form').parsley();

        //has uppercase
        window.Parsley.addValidator('uppercase', {
            requirementType: 'number',
            validateString: function(value, requirement) {
                var uppercases = value.match(/[A-Z]/g) || [];
                return uppercases.length >= requirement;
            },
            messages: {
                en: 'Your password must contain at least (%s) uppercase letter.'
            }
        });

        //has lowercase
        window.Parsley.addValidator('lowercase', {
            requirementType: 'number',
            validateString: function(value, requirement) {
                var lowecases = value.match(/[a-z]/g) || [];
                return lowecases.length >= requirement;
            },
            messages: {
                en: 'Your password must contain at least (%s) lowercase letter.'
            }
        });

        //has number
        window.Parsley.addValidator('number', {
            requirementType: 'number',
            validateString: function(value, requirement) {
                var numbers = value.match(/[0-9]/g) || [];
                return numbers.length >= requirement;
            },
            messages: {
                en: 'Your password must contain at least (%s) number.'
            }
        });

        Parsley.addMessages('de', {
            uppercase: "Ihr Passwort muss mind. 1 Grossbuchstaben enthalten.",
            lowercase: "Ihr Passwort muss mind. 1 Kleinbuchstaben enthalten.",
            number: "Ihr Passwort muss mind. 1 Zahl enthalten."
        });

        Parsley.addMessages('fr', {
            uppercase: "Votre mot de passe doit contenir au moins une lettre majuscule.",
            lowercase: "Votre mot de passe doit contenir au moins une lettre minuscule.",
            number: "Votre mot de passe doit contenir au moins 1 chiffre."
        });
    });
});
